const urlTool = {
  getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  addUrlParameter(url, key, value) {
    if (!url || !key || !value) {
      return url;
    }

    const pathArr = url.split('#');
    const addPath = pathArr[0];
    const hashPath = pathArr[1] ? `#${pathArr[1]}` : '';
    const separator = addPath.indexOf('?') !== -1 ? '&' : '?';

    return `${addPath}${separator}${key}=${value}${hashPath}`;
  },

  removeURLParameter(url, parameter) {
    const urlparts = url.split('?');

    if (urlparts.length >= 2) {
      const prefix = `${encodeURIComponent(parameter)}=`;
      const pars = urlparts[1].split(/[&;]/g);

      for (let i = pars.length; i-- > 0;) {
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      return urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
    }
    return url;
  },
};

export default urlTool;
